import { Button } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useState } from "react";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { useTaskContext } from "../context";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { TaskTopBanner } from "../TaskTopBanner";
import { taskOperationsList } from "../constants/task.constants";
import { updateTaskApi } from "API/apis/task/updateTask";
import dayjs from "configs/dayjs.config";

import { SearchUsers } from "components/SearchSelect/SearchUsers";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";

const initialUpdateValue = {
  id: 0,
  taskDetails: "",
  deadline: null,
  companyId: 0,
  taskTo: { name: "", dept: "", subDept: "", userId: "" },
};
export const UpdateTask = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const {
    setCurrentOperationPage,
    currentOperationPage,
    setReloadRequired,
    currentSelectedRowForUpdate,
  } = useTaskContext();

  const [formUpdateData, setFormUpdateData] = useState({
    ...currentSelectedRowForUpdate,
  });
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormUpdateData({
        ...formUpdateData,
        deadline: newValue.toDate(),
      });
    }
  };

  const handleChange = (e) => {
    setFormUpdateData({
      ...formUpdateData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUserTaskToSelection = (selectedUser) => {
    setFormUpdateData({
      ...formUpdateData,
      taskTo: selectedUser,
    });
  };
  const handleUserTaskBySelection = (selectedUser) => {
    setFormUpdateData({
      ...formUpdateData,
      taskBy: selectedUser,
    });
  };
  const handleUpdateTaskSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dayjs().subtract(1, "day") > formUpdateData.deadline) {
        throw new Error("Older dates are not allowed");
      }

      setIsLoading(true);
      const { data, status } = await updateTaskApi({
        ...formUpdateData,
        taskBy:
          currentOperationPage === taskOperationsList.updateTaskTo
            ? formUpdateData?.taskBy?.userId || ""
            : "",
        taskTo:
          currentOperationPage === taskOperationsList.updateTaskTo
            ? formUpdateData?.taskTo?.userId || ""
            : "",
      });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setSuccess(data?.message);

      setFormUpdateData(initialUpdateValue);
      setReloadRequired(true);
      setCurrentOperationPage(taskOperationsList.listTask);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };
  return (
    <>
      <PageTitle
        pageName={
          currentOperationPage === taskOperationsList.updateTaskTo
            ? pageName.task.updateTaskTo
            : pageName.task.updateTask
        }
      />
      <TaskTopBanner
        buttonType="back"
        taskOperationsParam={taskOperationsList.listTask}
      />
      <form onSubmit={handleUpdateTaskSubmit}>
        {currentOperationPage === taskOperationsList.updateTask && (
          <>
            <TextFieldWrapper
              multiline
              id="taskDetails"
              name="taskDetails"
              label="Task Detail"
              variant="outlined"
              value={formUpdateData.taskDetails}
              fullWidth
              required
              disabled={
                currentSelectedRowForUpdate.subDocId === 1 ? true : false
              }
              onChange={handleChange}
            />
            <TextFieldWrapper
              multiline
              id="taskDescription"
              name="taskDescription"
              label="Task Description"
              variant="outlined"
              value={formUpdateData.taskDescription}
              rows={5}
              fullWidth
              required
              disabled={
                currentSelectedRowForUpdate.subDocId === 1 ? true : false
              }
              onChange={handleChange}
            />
            <FormControlWrapper fullWidth>
              <DatePickerWrapper
                label="Delivery Date"
                value={dayjs(formUpdateData.deadline)}
                onChange={(newValue) =>
                  handleDeliveryDateChange(dayjs(newValue))
                }
              />
            </FormControlWrapper>
            <TextFieldWrapper
              id="alertBeforeDays"
              name="alertBeforeDays"
              label="Alert Before Days"
              variant="outlined"
              value={formUpdateData.alertBeforeDays}
              fullWidth
              inputProps={{ min: 1 }}
              required
              onChange={handleChange}
            />
          </>
        )}
        {currentOperationPage === taskOperationsList.updateTaskTo && (
          <>
            <FormControlWrapper fullWidth>
              <SearchUsers
                label="Assign To"
                handleUserSelection={handleUserTaskToSelection}
                selectedUser={formUpdateData.taskTo}
              />
            </FormControlWrapper>
            <FormControlWrapper fullWidth>
              <SearchUsers
                label="Assign By"
                handleUserSelection={handleUserTaskBySelection}
                selectedUser={formUpdateData.taskBy}
              />
            </FormControlWrapper>
          </>
        )}
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
